import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable, signal } from '@angular/core';
import { IModal, ModalConfig } from './modal.interface';

@Injectable({
  providedIn: 'root',
})
export class ModalService implements IModal {
  modals = signal<any[]>([]);

  currentOpenModal: DialogRef<any, ComponentType<any>> | null = null;

  constructor(private readonly dialog: Dialog) {}

  public create<T = any>(
    component: ComponentType<any>,
    config?: ModalConfig,
  ): DialogRef<T, ComponentType<any>> {
    this.currentOpenModal = this.dialog.open<T, unknown, ComponentType<any>>(
      component,
      {
        data: config?.componentProps,
        hasBackdrop: config?.hasBackdrop ?? true,
        disableClose: config?.disableClose ?? true,
        providers: config?.providers,
        autoFocus: false,
      },
    );

    this.modals.update((modals) => [...modals, this.currentOpenModal]);

    this.currentOpenModal.closed.subscribe({
      next: () => {
        this.modals.update((modals) =>
          modals.filter((modal) => modal !== this.currentOpenModal),
        );

        if (this.modals().length === 0) {
          this.currentOpenModal = null;
        } else {
          this.currentOpenModal = this.modals()[this.modals().length - 1];
        }
      },
    });

    return this.currentOpenModal;
  }

  close(result?: any) {
    if (this.currentOpenModal) {
      const element = this.getElement();

      if (element) {
        const closeAnimation = element.animate(
          [
            { opacity: 1, translateY: '0' },
            { opacity: 0, translateY: '10px' },
          ],
          {
            duration: 200,
            easing: 'ease-in-out',
          },
        );
        closeAnimation!.onfinish = () => {
          this.currentOpenModal!.close(result);
          // this.modals.update((modals) =>
          //   modals.filter(
          //     (modal) => modal !== this.currentOpenModal?.componentInstance,
          //   ),
          // );
          // this.currentOpenModal = null;
        };
      }
    }
  }

  getElement(): HTMLElement | null {
    const dialogs = document.querySelectorAll('cdk-dialog-container');
    const topId = dialogs.item(dialogs.length - 1)?.id;
    if (topId) {
      return document.getElementById(topId);
    }

    return null;
  }
}
